module.exports = __webpack_public_path__ + "img/minus.8d2673b8.svg";